module.exports = __webpack_public_path__ + "img/t2-c19.c25f05db.png";